/** Соответствует fishing/src/Twig/ModelExtension.php и меткам из App\Entity\Fish */

const MONTH_NAMES = {
    ru: {
        1: "Январь",
        2: "Февраль",
        3: "Март",
        4: "Апрель",
        5: "Май",
        6: "Июнь",
        7: "Июль",
        8: "Август",
        9: "Сентябрь",
        10: "Октябрь",
        11: "Ноябрь",
        12: "Декабрь",
    },
    en: {
        1: "January",
        2: "February",
        3: "March",
        4: "April",
        5: "May",
        6: "June",
        7: "July",
        8: "August",
        9: "September",
        10: "October",
        11: "November",
        12: "December",
    },
};

const FISHING_TYPE = {
    ru: { 1: "Спиннинг", 2: "Болонка", 3: "Матч", 4: "Штекер", 5: "Мах", 6: "Фидер", 7: "Донка", 8: "Нахлыст" },
    en: {},
};

const FISHING_TYPE_ORDER = [1, 2, 3, 4, 5, 6, 7, 8];

const BITE_WIND = {
    ru: { 0: "Штиль", 1: "Слабый", 2: "Умеренный", 3: "Сильный" },
    en: { 0: "Calm", 1: "Light", 2: "Moderate", 3: "Strong" },
};

const BITE_WIND_DIRECTION = {
    ru: { N: "Северный", NE: "Северо-восточный", E: "Восточный", SE: "Юго-восточный", S: "Южный", SW: "Юго-западный", W: "Западный", NW: "Северо-западный" },
    en: { N: "North", NE: "North-East", E: "East", SE: "South-East", S: "South", SW: "South-West", W: "West", NW: "North-West" },
};

const BITE_PRECIPITATION = {
    ru: { 0: "Без осадков", 1: "Слабый дождь", 2: "Дождь", 3: "Ливень", 4: "Снег" },
    en: { 0: "No precipitation", 1: "Light rain", 2: "Rain", 3: "Downpour", 4: "Snow" },
};

const BITE_CLOUDINESS = {
    ru: { 0: "Ясно", 1: "Переменная", 2: "Облачно", 3: "Пасмурно" },
    en: { 0: "Clear", 1: "Partly cloudy", 2: "Cloudy", 3: "Overcast" },
};

const BITE_PREASURE = {
    ru: { 0: "Стабильное", [-1]: "Падает", [-2]: "Пониженное", 1: "Растет", 2: "Повышенное" },
    en: { 0: "Stable", [-1]: "Falling", [-2]: "Low", 1: "Rising", 2: "High" },
};

const BITE_MOON = {
    ru: { 0: "Новолуние", 1: "Первая четверть", 2: "Полнолуние", 3: "Последняя четверть", 4: "Растущая" },
    en: { 0: "New moon", 1: "First quarter", 2: "Full moon", 3: "Last quarter", 4: "Waxing" },
};

const PLACE_FLOW = {
    ru: { 0: "Отсутствует", 1: "Слабое", 2: "Умеренное", 3: "Сильное" },
    en: { 0: "None", 1: "Weak", 2: "Moderate", 3: "Strong" },
};

const PLACE_SHADOW = {
    ru: { 0: "Открытое место", 1: "Тень", 2: "Растительность", 3: "Камни", 4: "Ил", 5: "Песчаное дно", 6: "Глубокие участки", 7: "Прибрежная зона", 8: "Перекаты", 9: "Коряги, укрытия" },
    en: { 0: "Open area", 1: "Shade", 2: "Vegetation", 3: "Rocks", 4: "Silt", 5: "Sandy bottom", 6: "Deep areas", 7: "Coastal zone", 8: "Rapids", 9: "Snags, shelters" },
};

const TIME_ACTIVE_BITE = {
    ru: { 0: "Раннее утро", 1: "Утро", 2: "День", 3: "Вечер", 4: "Поздний вечер", 5: "Ночь", 6: "Утро, вечер", 7: "Вечер, ночь", 8: "Весь день", 9: "Утро, день", 10: "Ночь, раннее утро" },
    en: { 0: "Early morning", 1: "Morning", 2: "Day", 3: "Evening", 4: "Late evening", 5: "Night", 6: "Morning, evening", 7: "Evening, night", 8: "All day", 9: "Morning, day", 10: "Night, early morning" },
};

function pick(map, key, lang = "ru") {
    if (key === null || key === undefined) return "";
    const table = map[lang] ?? map.ru;
    return table[key] ?? "";
}

export function formatSpawningMonths(months, lang = "ru") {
    if (!months?.length) return "";
    const table = MONTH_NAMES[lang] ?? MONTH_NAMES.ru;
    const parts = months
        .map((m) => table[parseInt(String(m).trim(), 10)])
        .filter(Boolean);
    return parts.join(", ");
}

/** Как в старом шаблоне: ветер — подпись или «Любой», если не задано */
export function formatBiteWind(value, lang = "ru") {
    if (value === null || value === undefined) return lang === "en" ? "Any" : "Любой";
    return pick(BITE_WIND, value, lang) || String(value);
}

export function formatBiteWindDirection(code, lang = "ru") {
    if (code === null || code === undefined || code === "") return "";
    const c = String(code).trim().toUpperCase();
    return (BITE_WIND_DIRECTION[lang] ?? BITE_WIND_DIRECTION.ru)[c] || String(code);
}

export function formatBitePrecipitation(v, lang = "ru") {
    return pick(BITE_PRECIPITATION, v, lang);
}
export function formatFishingType(v, lang = "ru") {
    if (v === null || v === undefined || v === "" || Number(v) === 0) {
        return "";
    }

    if (Array.isArray(v)) {
        return v.map(item => pick(FISHING_TYPE, item, lang)).filter(Boolean).join(", ");
    }

    if (typeof v === "string" && v.includes(",")) {
        return v.split(",")
            .map(item => pick(FISHING_TYPE, item.trim(), lang))
            .filter(Boolean)
            .join(", ");
    }

    return pick(FISHING_TYPE, v, lang);
}

/** Опции `<select>` типа ловли: 0 — «Выбрать», далее как в FISHING_TYPE */
export function fishingTypeSelectOptions(lang = "ru") {
    const table = FISHING_TYPE[lang] ?? FISHING_TYPE.ru;
    const opts = [];
    for (const id of FISHING_TYPE_ORDER) {
        const label = table[id];
        if (label) opts.push({ value: String(id), label });
    }
    return opts;
}
export function formatBiteCloudiness(v, lang = "ru") {
    return pick(BITE_CLOUDINESS, v, lang);
}
export function formatBitePreasure(v, lang = "ru") {
    return pick(BITE_PREASURE, v, lang);
}
export function formatBiteMoon(v, lang = "ru") {
    return pick(BITE_MOON, v, lang);
}
export function formatPlaceFlow(v, lang = "ru") {
    return pick(PLACE_FLOW, v, lang);
}
export function formatPlaceShadow(v, lang = "ru") {
    return pick(PLACE_SHADOW, v, lang);
}
export function formatTimeActiveBite(v, lang = "ru") {
    return pick(TIME_ACTIVE_BITE, v, lang);
}

export function formatTempRange(start, end) {
    const a = start != null ? start : "—";
    const b = end != null ? end : "—";
    return `${a} - ${b}`;
}

export function formatDepthRange(start, end) {
    const a = start != null ? start : "—";
    const b = end != null ? end : "—";
    return `${a} - ${b}`;
}
